module.exports = __webpack_public_path__ + "img/Slider_montagne_mobile-DJ.c080a470.png";